export const ROOT_PATH = 'content/:contentUuid' as const;
export const ERROR_PATH = '/error' as const;

export const ALL_PATHS = [ROOT_PATH, ERROR_PATH] as const;
